<!-- 企业级-业务中心-业务领域 -->
<template>
  <div class="mainArea CBusiness">
      <!-- 主要头部内容 -->
      <div class="mainHeadContent">
        <!-- 面包屑 -->
        <CBreadCrumb></CBreadCrumb>
      </div>
      <!--主内容区-->
      <div class="mainBodyContent">
        <div class="search mb20">
          <el-button type="primary" @click="openBussin">添加业务</el-button>
        </div>
        <div class="cont">
          <div v-for="(item,index) in bussinessList" :key="index">
          <div class="tit" v-if="item.children!=''">{{item.name}}</div>
          <div class="list flex">
            <div class="item" v-for="(buss,index2) in item.children" :key="index2"  @click="toDetail(buss.type_id)">
              <div class="img">
                <!-- <img :src="buss.image" alt=""> -->
                <img src="../../../../static/images/icon/icon_1.png" alt="" v-if="buss.type_id == 'ez'">
                <img src="../../../../static/images/icon/icon_5.png" alt="" v-if="buss.type_id == 'wrc'">
                <img src="../../../../static/images/icon/icon_10.png" alt="" v-if="buss.type_id == 'jtws'">
                <img src="../../../../static/images/icon/icon_2.png" alt="" v-if="buss.type_id == 'kd'">
                <img src="../../../../static/images/icon/icon_4.png" alt="" v-if="buss.type_id == 'smzf'">
                <img src="../../../../static/images/icon/icon_7.png" alt="" v-if="buss.type_id == 'yy'">
                <img src="../../../../static/images/icon/icon_8.png" alt="" v-if="buss.type_id == 'mjyy'">
                <img src="../../../../static/images/icon/icon_21.png" alt="" v-if="buss.type_id == 'hysy'">
              </div>
              <div class="name">{{buss.name}}</div>
              <div class="itemBtn" @click.stop>
                <div class="btn" v-if="buss.type_id != 'jtws'" @click="openAdd(buss.type_id)">一键配置</div>
                <div class="btn" @click="toDetail(buss.type_id)">详情</div>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
      <!--添加业务-->
      <el-dialog title="添加业务" :visible.sync="businessDio" width="600px" class="bussiDio">
        <div class="contDio">
          <el-checkbox-group v-model="addbuss.bussiness">
            <div v-for="(item,index) in allBussine" :key="index">
              <div class="tit">{{item.name}}</div>
              <el-checkbox :label="allbuss.type_id" border v-for="(allbuss,index2) in item.children" :key="index2">{{allbuss.name}}</el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="businessDio = false">取消</el-button>
          <el-button type="primary" @click="changeBussiness">确定</el-button>
        </span>
      </el-dialog>

      <!--配置业务-->
      <el-dialog :title="titleDio" :visible.sync="configDio" width="700px" class="configDio">
        <!--e站-->
        <template v-if="type_Dio == 'ez'">
        <div class="contDio">
          <el-form ref="form" :rules="rules" :model="addform" label-width="90px">
            <el-form-item label="所属空间:" prop="space_id">
              <el-cascader
                class="db"
                :options="spaceList"
                v-model="addform.space_id"
                change-on-select
                :props="selectProps" 
                @change="getSpaceDeviceTypeList(addform.space_id[addform.space_id.length-1],'ESTAND')">
              </el-cascader>
            </el-form-item>
            <el-form-item label="设备名称:" prop="device_id">
              <el-select v-model="addform.device_id" placeholder="请选择设备名称" class="db">
                <el-option
                  v-for="item in deviceList"
                  :key="item.device_no_id"
                  :label="item.device_name"
                  :value="item.device_no_id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备ID:">
              {{addform.device_id}}
            </el-form-item>
            <el-form-item label="子库:" prop="original_data">
              <el-input placeholder="请输入子库" v-model="addform.original_data"></el-input>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input type="textarea" :rows="4" placeholder="请输入备注" v-model="addform.desc"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addConfig('form')">确定</el-button>
          <el-button @click="configDio = false">取消</el-button>
        </span>
        </template>
        <!--无人仓-->
        <template v-else-if="type_Dio == 'wrc'">
        <div class="contDio">
          <el-form ref="form" :rules="rules" :model="addform" label-width="90px">
            <el-form-item label="所属空间:" prop="space_id">
              <el-cascader
                class="db"
                :options="spaceList"
                v-model="addform.space_id"
                change-on-select
                :props="selectProps" 
                @change="getSpaceDeviceTypeList(addform.space_id[addform.space_id.length-1])">
              </el-cascader>
            </el-form-item>
            <el-form-item label="设备名称:" prop="device_id">
              <el-select v-model="addform.device_id" placeholder="请选择设备名称" class="db">
                <el-option
                  v-for="item in deviceList"
                  :key="item.device_no_id"
                  :label="item.device_name"
                  :value="item.device_no_id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备ID:">
              {{addform.device_id}}
            </el-form-item>
            <el-form-item label="子库:" prop="original_data">
              <el-input placeholder="请输入子库" v-model="addform.original_data"></el-input>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input type="textarea" :rows="4" placeholder="请输入备注" v-model="addform.desc"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="addConfig('form')">确定</el-button>
          <el-button @click="configDio = false">取消</el-button>
        </span>
        </template>
        <!--快递-->
        <template v-else-if="type_Dio == 'kd'">
        <div class="contDio">
          <div class="stepDiv">
            <el-steps :active="kdform.stepActive">
              <el-step title="绑定设备"></el-step>
              <el-step title="添加快递员"></el-step>
            </el-steps>
          </div>
          <div v-if="kdform.stepActive == 1" key="4">
          <el-form ref="form2" :rules="rules2" :model="kdform" label-width="90px">
            <el-form-item label="所属空间:" prop="space_id">
              <el-cascader
                :options="spaceList"
                v-model="kdform.space_id"
                change-on-select
                :props="selectProps" 
                @change="getSpaceDeviceKd(kdform.space_id[kdform.space_id.length-1])">
              </el-cascader>
            </el-form-item>
            <el-form-item label="设备名称:" prop="device_id">
              <div class="flex">
                <el-select v-model="kdform.device_id" placeholder="请选择设备名称" @change="getDeviType">
                  <el-option
                    v-for="item in deviceList2"
                    :key="item.device_no_id"
                    :label="item.device_name"
                    :value="item.device_no_id">
                  </el-option>
                </el-select>
                <div class="ml20 mr20">设备类型:{{kdform.type}}</div>
                <div class="mr20">设备ID:{{kdform.device_id}}</div>
                <div><el-button type="primary" @click="addDeviArr('form2')">添加</el-button></div>
              </div>
            </el-form-item>
          </el-form>
          <el-table :data="kdform.deviceData" style="width: 100%">
            <el-table-column type="index" label="序号" width="90px"></el-table-column>
            <el-table-column prop="type" label="设备类型"></el-table-column>
            <el-table-column prop="device_id" label="设备ID"></el-table-column>
            <el-table-column prop="device_name" label="设备名称"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="delDeviArr(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          </div>
          <div v-else key="3">
          <el-form ref="form3" :rules="rules3" :model="kdform2" label-width="90px" :inline="true">
            <el-form-item label="姓名:">
              <div class="flex">
                <el-input v-model="kdform2.fullname" class="w185" key="fullname"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="手机号码:" prop="phone">
              <el-input v-model="kdform2.phone" class="w185" key="phone"></el-input>
            </el-form-item>
            <el-form-item label="身份证:" prop="idcart">
              <div class="flex">
                <el-input v-model="kdform2.idcart" class="w185" key="idcart"></el-input>
              </div>
            </el-form-item>
            <el-form-item label="快递公司:">
              <div class="flex">
                <div><el-input v-model="kdform2.company" class="w185" key="company"></el-input></div>
                <div class="ml10"><el-button type="primary" @click="addUserArr('form3')">添加</el-button></div>
              </div>
            </el-form-item>
          </el-form>
          <el-table :data="kdform2.userData" style="width: 100%">
            <el-table-column type="index" label="序号" width="90px"></el-table-column>
            <el-table-column prop="user_name" label="姓名"></el-table-column>
            <el-table-column prop="phone_no" label="手机号码"></el-table-column>
            <el-table-column prop="identity" label="身份证"></el-table-column>
            <el-table-column prop="express_company" label="所属快递公司"></el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-button type="text" @click="delUserArr(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <div v-if="kdform.stepActive == 1" key="1">
          <el-button @click="configDio = false">取消</el-button>
          <el-button @click="nextStep">下一步</el-button>
          </div>
          <div v-else key="2">
          <el-button @click="kdform.stepActive = 1">上一步</el-button>
          <el-button type="primary" @click="configKuaidi">确定</el-button>
          </div>
        </span>
        </template>
        <!--预约业务-->
        <template v-else-if="type_Dio == 'yy'">
        <div class="contDio">
          <div class="stepDiv">
            <el-steps :active="yyform.stepActive">
              <el-step title="添加基本信息"></el-step>
              <el-step title="添加设备ID"></el-step>
            </el-steps>
          </div>
          <div v-if="yyform.stepActive == 1" key="9">
          <el-form ref="form4" :rules="rules4" :model="yyform" label-width="90px">
            <el-form-item label="预约名称:" prop="yyName">
              <el-input v-model="yyform.yyName" key="yyName"></el-input>
            </el-form-item>
            <el-form-item label="预约网址:" prop="website">
              <el-input v-model="yyform.website" key="website"></el-input>
            </el-form-item>
            <el-form-item>
              <span slot="label">
                <el-checkbox v-model="yyform.isApprover">审批人:</el-checkbox>
              </span>
              <template v-if="yyform.isApprover">
              <el-cascader
                class="db mb20"
                :options="deparList"
                v-model="yyform.depart_id"
                change-on-select
                :props="selectProps2" 
                @change="getUserYy(yyform.depart_id[yyform.depart_id.length-1])">
              </el-cascader>
              <el-select v-model="yyform.user_id" placeholder="请选择审批人" class="db">
                <el-option
                  v-for="item in userYyList"
                  :key="item.user_id"
                  :label="item.user_name"
                  :value="item.user_id">
                </el-option>
              </el-select>
              </template>
            </el-form-item>
          </el-form>
          </div>
          <div v-else key="10">
          <el-form ref="form7" :model="yyform2" label-width="90px">
            <el-form-item label="查找方式:">
              <el-select v-model="yyform2.mode" placeholder="请选择查找方式" class="db">
                <el-option label="按空间查找" value="1"></el-option>
                <el-option label="按类型查找" value="2"></el-option>
              </el-select>
            </el-form-item>
            <template v-if="yyform2.mode=='1'">
            <el-form-item label="所属空间:">
              <el-cascader
                class="db"
                :options="spaceList"
                v-model="yyform2.space_id"
                change-on-select
                :props="selectProps"
                @change="getSpaceDeviceYy(yyform2.space_id[yyform2.space_id.length-1])">
              </el-cascader>
            </el-form-item>
            </template>
            <template v-if="yyform2.mode=='2'">
            <el-form-item label="类型:">
              <div class="flex">
              <el-select v-model="yyform2.type" placeholder="请选择设备类型" @change="typeChangeYy">
                <el-option
                  v-for="item in deviceType"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <template v-if="yyform2.typeCode=='ACCESS'">
              <div class="ml20">门禁级别：</div>
              <el-select v-model="yyform2.typeSpecif" placeholder="请选择门禁级别" @change="getDeviceListByType(yyform2.typeSpecif)">
                <el-option label="A" value="A"></el-option>
                <el-option label="B" value="B"></el-option>
                <el-option label="C" value="C"></el-option>
              </el-select>
              </template>
              </div>
            </el-form-item>
            </template>
          </el-form>
          <!-- <el-transfer
            style="text-align: left; display: inline-block"
            v-model="yyform2.device_id"
            filterable
            filter-placeholder="请输入搜索内容"
            :titles="['未选择设备', '已选择设备']"
            :button-texts="['to left', 'to right']"
            :format="{
              noChecked: '${total}',
              hasChecked: '${checked}/${total}'
            }"
            :data="deviceList3"
            :props="transProps"
            :render-content="renderFunc"
            :filter-method="filterMethod">
          </el-transfer> -->
          <!--穿梭框-->
          <div class="tranferEdit flex">
            <div class="tranItem">
              <div class="tranTit">
                <el-checkbox :indeterminate="leftinfo.isIndeterminate" v-model="leftinfo.checkAll" @change="leftAllChange">未选择设备</el-checkbox>
                <div class="number"><template v-if="leftinfo.checkNum!=0">{{leftinfo.checkNum}}/</template>{{leftinfo.total}}</div>
              </div>
              <div class="search">
                <el-input size="medium" placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="leftinfo.keyword"></el-input>
              </div>
              <div class="tranList">
                <template v-if="leftinfo.deviceData!=''">
                <el-checkbox-group v-model="leftinfo.ischeck" @change="leftChange">
                  <el-checkbox v-for="(item,index) in leftinfo.deviceData" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-checkbox>
                </el-checkbox-group>
                </template>
                <div class="noData" v-else>暂无数据...</div>
              </div>
            </div>
            <div class="btnDiv">
              <div>
                <el-button icon="el-icon-arrow-left" v-if="rightinfo.ischeck==''">to left</el-button>
                <el-button type="primary" icon="el-icon-arrow-left" v-else @click="toLeft">to left</el-button>
              </div>
              <div>
                <el-button v-if="leftinfo.ischeck==''">to right<i class="el-icon-arrow-right"></i></el-button>
                <el-button type="primary" v-else @click="toRight">to right<i class="el-icon-arrow-right"></i></el-button>
              </div>
            </div>
            <div class="tranItem">
              <div class="tranTit">
                <el-checkbox :indeterminate="rightinfo.isIndeterminate" v-model="rightinfo.checkAll" @change="rightAllChange">已选择设备</el-checkbox>
                <div class="number"><template v-if="rightinfo.checkNum!=0">{{rightinfo.checkNum}}/</template>{{rightinfo.total}}</div>
              </div>
              <div class="search">
                <el-input size="medium" placeholder="请输入搜索内容" prefix-icon="el-icon-search" v-model="rightinfo.keyword"></el-input>
              </div>
              <div class="tranList">
                <template v-if="rightinfo.deviceData!=''">
                <el-checkbox-group v-model="rightinfo.ischeck" @change="rightChange">
                  <el-checkbox v-for="(item,index) in rightinfo.deviceData" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-checkbox>
                </el-checkbox-group>
                </template>
                <div class="noData" v-else>暂无数据...</div>
              </div>
            </div>
          </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <div v-if="yyform.stepActive == 1" key="11">
          <el-button @click="configDio = false">取消</el-button>
          <el-button @click="nextStep3('form4')">下一步</el-button>
          </div>
          <div v-else key="2">
          <el-button @click="yyform.stepActive = 1">上一步</el-button>
          <el-button type="primary" @click="submitYuyue()">确定</el-button>
          </div>
        </span>
        </template>

        <!--扫码支付-->
        <template v-else-if="type_Dio == 'smzf'">
        <div class="contDio">
          <div class="stepDiv mb20">
            <el-steps :active="smzfform.stepActive">
              <el-step title="设置价格策略"></el-step>
              <el-step title="绑定设备"></el-step>
            </el-steps>
          </div>
          <div v-if="smzfform.stepActive == 1" key="7">
          <el-form ref="form5" :rules="rules5" :model="smzfform" label-width="90px">
            <el-form-item label="价格策略:" prop="tactics_id">
              <el-select v-model="smzfform.tactics_id" placeholder="请选择价格策略" class="db">
                <el-option label="新增价格策略" value="0"></el-option>
                <el-option
                  v-for="item in tacticsList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <template v-if="smzfform.tactics_id == '0'">
            <el-form-item label="价格名称:" prop="tactics_name">
              <el-input v-model="smzfform.tactics_name" placeholder="如寄存柜支付开门等"></el-input>
            </el-form-item>
            <el-form-item label="支付平台:">
              <el-select v-model="smzfform.payPlat" placeholder="请选择支付平台">
                <el-option label="微信" value="1"></el-option>
                <el-option label="支付宝" value="2"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="支付方式:" prop="price">
              <div class="flex">
                <el-select v-model="smzfform.payMethod" placeholder="请选择支付方式">
                  <el-option label="按时间" value="1"></el-option>
                  <el-option label="按次数" value="2"></el-option>
                </el-select>
                <div class="ml20">
                  费用：<el-input v-model="smzfform.price" placeholder="请输入费用" class="w185"></el-input>
                  <template v-if="smzfform.payMethod == '1'">元/小时</template><template v-else>元/次</template>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="周末费用:">
              <div class="flex week">
                <el-checkbox v-model="smzfform.weekend">单独设置周末费用</el-checkbox>
                <div class="ml20" v-if="smzfform.weekend == true">
                  费用：<el-input v-model="smzfform.weekPrice" placeholder="请输入费用" class="w185"></el-input>
                  <template v-if="smzfform.payMethod == '1'">元/小时</template><template v-else>元/次</template>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="节假日费用:">
              <div class="flex week">
                <el-checkbox v-model="smzfform.holiday">单独设置节假日费用</el-checkbox>
                <div class="ml20" v-if="smzfform.holiday == true">
                  费用：<el-input v-model="smzfform.holiPrice" placeholder="请输入费用" class="w185"></el-input>
                  <template v-if="smzfform.payMethod == '1'">元/小时</template><template v-else>元/次</template>
                </div>
              </div>
            </el-form-item>
            </template>
          </el-form>
          </div>
          <div v-else key="8">
            <el-form ref="form6" :rules="rules2" :model="smzfform" label-width="90px">
            <el-form-item label="所属空间:" prop="space_id">
              <el-cascader
                class="db"
                :options="spaceList"
                v-model="smzfform.space_id"
                change-on-select
                :props="selectProps" 
                @change="getSpaceDeviceSmzf(smzfform.space_id[smzfform.space_id.length-1])">
              </el-cascader>
            </el-form-item>
            <el-form-item label="设备名称:" prop="device_id">
              <el-select v-model="smzfform.device_id" placeholder="请选择设备名称" @change="getDeviType3" class="db">
                <el-option
                  v-for="item in deviceList4"
                  :key="item.device_no_id"
                  :label="item.device_name"
                  :value="item.device_no_id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型:">{{smzfform.type}}</el-form-item>
            <el-form-item label="设备ID:">{{smzfform.device_id}}</el-form-item>
          </el-form>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <div v-if="smzfform.stepActive == 1" key='5'>
          <el-button @click="configDio = false">取消</el-button>
          <el-button @click="nextStep2('form5')">下一步</el-button>
          </div>
          <div v-else key="6">
          <el-button @click="prevStep">上一步</el-button>
          <el-button type="primary" @click="submitSmzf('form6')">确定</el-button>
          </div>
        </span>
        </template>

        <!--门禁预约-->
        <template v-else-if="type_Dio == 'mjyy'">
        <div class="stepMjyy">
          <div class="item" :class="{'activeStep' : mjyyform.addStep == 1}">1、编辑名称</div>
          <div class="item" :class="{'activeStep' : mjyyform.addStep == 2}">2、选择设备</div>
          <div class="item" :class="{'activeStep' : mjyyform.addStep == 3}">3、设置审批</div>
        </div>
        <template v-if="mjyyform.addStep == 1">
          <div class="contDio minH300">
            <div class="tipsMjyy tc"><p>为新建项目命名</p><p>以根据名称区别不同的门禁预约项目</p></div>
            <el-input placeholder="请输入项目名称" v-model="mjyyform.projectName"></el-input>
          </div>
          <span slot="footer">
            <el-button @click="configDio = false">取 消</el-button>
            <el-button type="primary" @click="nextStepMjyy('1')">下一步</el-button>
          </span>
          </template>
          <template v-else-if="mjyyform.addStep == 2">
          <div class="contDio minH300">
            <div class="tipsMjyy tc"><p>选择预约包含的门禁设备</p><p>用户预约成功后，将获得这些门禁的使用权限</p></div>
            <div class="tit flex">
              <div>授权设备：</div>
              <div class="col6">已选择：{{mjyyform.device_id.length}}项</div>
            </div>
            <div class="authUserList flex">
              <div class="userTree">
                <div class="titSubMjyy">空间列表</div>
                <el-tree
                ref="tree"
                class="defineTree"
                :data="spaceList"
                highlight-current
                default-expand-all
                node-key="space_id"
                :expand-on-click-node="false"
                :props="treeProps"
                @node-click="getNodeMjyy">
                  <span class="custom-tree-node" slot-scope="{ node,data }">
                    <i
                      class="defineIcon"
                      :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                    </i>
                    <span class="label" :class="data.space_id === mjyyform.space_id ? 'selectedTree' : ''">{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
              <div class="checkList">
                <div class="titSubMjyy">设备列表</div>
                <div class="search">
                  <el-input size="small" placeholder="请输入设备ID或设备名称" prefix-icon="el-icon-search" v-model="mjyyform.search" @input="searchInputMjyy"></el-input>
                  <div class="sizeDiv">
                    <p>门禁级别：</p>
                    <el-checkbox-group v-model="mjyyform.sizeCheck" @change="getSpaceDeviceMjyy(mjyyform.space_id,'1',mjyyform.sizeCheck)">
                      <el-checkbox label="A"></el-checkbox>
                      <el-checkbox label="B"></el-checkbox>
                      <el-checkbox label="C"></el-checkbox>
                    </el-checkbox-group>
                  </div>
                </div>
                <el-checkbox class="dblock" :indeterminate="mjyyform.isIndeterminate" v-model="mjyyform.checkAll" @change="CheckAllChangeMjyy">全选</el-checkbox>
                <el-checkbox-group class="groupH" v-model="mjyyform.device_id" @change="CheckedItemChangeMjyy">
                  <el-checkbox class="dblock" v-for="(item,index) in deviceListMjyy" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <span slot="footer">
            <el-button type="primary" @click="prevStepMjyy">上一步</el-button>
            <el-button type="primary" @click="nextStepMjyy('1')">下一步</el-button>
          </span>
          </template>
          <template v-else>
          <div class="contDio minH300">
            <div class="tipsMjyy tc"><p>设置审批人，则用户提交预约后</p><p>需要审批人通过后再由被访人通过</p><p>或在后台通过审批方可获得授权</p></div>
            <el-checkbox v-model="mjyyform.isCheck" @change="mjyyform.userName='';mjyyform.user_id=''">设置审批人（如不勾选则只需被访人审批）</el-checkbox>
            <div class="tit flex">
              <div>设置审批人：{{mjyyform.userName}}</div>
            </div>
            <div class="authUserList flex" v-if="mjyyform.isCheck">
              <div class="userTree">
                <div class="titSubMjyy">部门列表</div>
                <el-tree
                ref="tree"
                class="defineTree"
                :data="deparList"
                highlight-current
                default-expand-all
                node-key="id"
                :expand-on-click-node="false"
                :props="treeProps2"
                @node-click="getNode2Mjyy">
                  <span class="custom-tree-node" slot-scope="{ node,data }">
                    <i
                      class="defineIcon"
                      :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                    </i>
                    <span class="label" :class="data.id === mjyyform.depart_id ? 'selectedTree' : ''">{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
              <div class="checkList">
                <div class="titSubMjyy">人员列表</div>
                <div class="search pdtb6">
                  <el-input size="small" placeholder="请输入姓名或手机号码" prefix-icon="el-icon-search" v-model="mjyyform.search2" @input="searchUserMjyy"></el-input>
                </div>
                <el-radio-group class="groupH" v-model="mjyyform.user_id" @change="getuserNameMjyy">
                  <el-radio class="dblock" v-for="(item,index) in auditorListMjyy" :label="item.user_id" :key="index">{{item.user_name}}-{{item.phone_no}}</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
            <span slot="footer">
              <el-button type="primary" @click="prevStepMjyy">上一步</el-button>
              <el-button type="primary" @click="submitConfigMjyy('1')">确定</el-button>
            </span>
          </template>
        </template>

        <!--会议室预约-->
        <template v-else-if="type_Dio == 'hysy'">
        <div class="stepMjyy">
          <div class="item" :class="{'activeStep' : mjyyform.addStep == 1}">1、编辑名称</div>
          <div class="item" :class="{'activeStep' : mjyyform.addStep == 2}">2、选择设备</div>
          <div class="item" :class="{'activeStep' : mjyyform.addStep == 3}">3、设置审批</div>
        </div>
        <template v-if="mjyyform.addStep == 1">
          <div class="contDio minH300">
            <div class="tipsMjyy tc"><p>为新建会议室命名</p><p>以根据名称区别不同的会议室</p></div>
            <el-input class="mb20" placeholder="请输入会议室名称" v-model="mjyyform.projectName"></el-input>
            <el-input placeholder="请输入会议室地址" v-model="mjyyform.projectUrl"></el-input>
          </div>
          <span slot="footer">
            <el-button @click="configDio = false">取 消</el-button>
            <el-button type="primary" @click="nextStepMjyy('2')">下一步</el-button>
          </span>
          </template>
          <template v-else-if="mjyyform.addStep == 2">
          <div class="contDio minH300">
            <div class="tipsMjyy tc"><p>选择会议室包含的设备</p><p>用户预约成功后，将获得这些设备的使用权限</p></div>
            <div class="tit flex">
              <div>授权设备：</div>
              <div class="col6">已选择：{{mjyyform.device_id.length}}项</div>
            </div>
            <div class="authUserList flex">
              <div class="userTree">
                <div class="titSubMjyy">空间列表</div>
                <el-tree
                ref="tree"
                class="defineTree"
                :data="spaceList"
                highlight-current
                default-expand-all
                node-key="space_id"
                :expand-on-click-node="false"
                :props="treeProps"
                @node-click="getNodeMjyy2">
                  <span class="custom-tree-node" slot-scope="{ node,data }">
                    <i
                      class="defineIcon"
                      :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                    </i>
                    <span class="label" :class="data.space_id === mjyyform.space_id ? 'selectedTree' : ''">{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
              <div class="checkList">
                <div class="titSubMjyy">设备列表</div>
                <div class="search">
                  <el-input size="small" placeholder="请输入设备ID或设备名称" prefix-icon="el-icon-search" v-model="mjyyform.search" @input="searchInputMjyy"></el-input>
                </div>
                <el-checkbox class="dblock" :indeterminate="mjyyform.isIndeterminate" v-model="mjyyform.checkAll" @change="CheckAllChangeMjyy">全选</el-checkbox>
                <el-checkbox-group class="groupH" v-model="mjyyform.device_id" @change="CheckedItemChangeMjyy">
                  <el-checkbox class="dblock" v-for="(item,index) in deviceListMjyy" :label="item.device_no_id" :key="index">{{item.device_no_id}}-{{item.device_name}}</el-checkbox>
                </el-checkbox-group>
              </div>
            </div>
          </div>
          <span slot="footer">
            <el-button type="primary" @click="prevStepMjyy">上一步</el-button>
            <el-button type="primary" @click="nextStepMjyy('2')">下一步</el-button>
          </span>
          </template>
          <template v-else>
          <div class="contDio minH300">
            <div class="tipsMjyy tc"><p>设置审批人，则用户提交预约后</p><p>需要审批人或在后台通过审批方可获得授权</p></div>
            <el-checkbox v-model="mjyyform.isCheck" @change="mjyyform.userName='';mjyyform.user_id=''">设置审批人（如不勾选则只需被访人审批）</el-checkbox>
            <div class="tit flex">
              <div>设置审批人：{{mjyyform.userName}}</div>
            </div>
            <div class="authUserList flex" v-if="mjyyform.isCheck">
              <div class="userTree">
                <div class="titSubMjyy">部门列表</div>
                <el-tree
                ref="tree"
                class="defineTree"
                :data="deparList"
                highlight-current
                default-expand-all
                node-key="id"
                :expand-on-click-node="false"
                :props="treeProps2"
                @node-click="getNode2Mjyy">
                  <span class="custom-tree-node" slot-scope="{ node,data }">
                    <i
                      class="defineIcon"
                      :class="{ 'el-icon-plus': !node.expanded, 'el-icon-minus':node.expanded, opacity: node.childNodes.length === 0}">
                    </i>
                    <span class="label" :class="data.id === mjyyform.depart_id ? 'selectedTree' : ''">{{ node.label }}</span>
                  </span>
                </el-tree>
              </div>
              <div class="checkList">
                <div class="titSubMjyy">人员列表</div>
                <div class="search pdtb6">
                  <el-input size="small" placeholder="请输入姓名或手机号码" prefix-icon="el-icon-search" v-model="mjyyform.search2" @input="searchUserMjyy"></el-input>
                </div>
                <el-radio-group class="groupH" v-model="mjyyform.user_id" @change="getuserNameMjyy">
                  <el-radio class="dblock" v-for="(item,index) in auditorListMjyy" :label="item.user_id" :key="index">{{item.user_name}}-{{item.phone_no}}</el-radio>
                </el-radio-group>
              </div>
            </div>
          </div>
            <span slot="footer">
              <el-button type="primary" @click="prevStepMjyy">上一步</el-button>
              <el-button type="primary" @click="submitConfigMjyy('2')">确定</el-button>
            </span>
          </template>
        </template>
      </el-dialog>
  </div>
</template>

<script>
  import CBreadCrumb from "../Layout/CBreadCrumb.vue"
  import { showToast,updataBreadCrumb } from "../../../../static/js/utility/utility.js"
  import { unmanApi, eSiteApi, sceneApi, bussinessApi,userApi } from "../../../../static/js/api.js"

  export default {
    name: 'CBusiness',
    components: {
      CBreadCrumb
    },
    data() {
      return {
        bussinessList:[],//已启用业务

        businessDio:false,//添加业务弹窗
        allBussine:[],//所有业务
        addbuss:{
          bussiness:[],
        },

        titleDio:'',
        configDio:false,
        type_Dio:'',

        addform:{
          device_id:'',
          original_data:'',
          desc:'',
          device_name:'',
          space_id:[],
        },
        rules:{
          space_id:[
            { required: true, message: '请选择空间', trigger: 'blur' },
          ],
          device_id:[
            { required: true, message: '请选择设备名称', trigger: 'blur' },
          ],
          original_data:[
            { required: true, message: '请输入子库', trigger: 'blur' },
          ]
        },
        spaceList:[],//空间列表
        deviceList:[],//设备列表
        // 级联选择器配置
        selectProps: {
          label: 'space_name',
          value: 'space_id',
          children: 'children'
        },
        selectProps2:{
          label: 'name',
          value: 'id',
          children: 'children'
        },

        kdform:{
          stepActive:1,//步骤
          device_name:'',//设备名称
          device_id:'',//设备id
          space_id:[],//空间id
          type:'',//设备类型
          deviceData:[],//设备表格
        },
        rules2:{
          space_id:[
            { required: true, message: '请选择空间', trigger: 'blur' },
          ],
          device_id:[
            { required: true, message: '请选择设备名称', trigger: 'blur' },
          ],
        },
        kdform2:{
          fullname:'',//姓名
          phone:'',//手机号
          idcart:'',//身份证
          company:'',//快递公司
          userData:[],//用户表格
        },
        rules3:{
          phone:[
            { required: true, message: "请输入电话", trigger: 'blur' },
					  { pattern: /^1[3|4|5|7|8|9][0-9]\d{8}$/,message:'请输入正确的手机号'}
          ],
          idcart:[
            { required: true, message: '请输入身份证号', trigger: 'blur' },
            { pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,message:'请输入正确的身份证号'}
          ],
        },
        deviceList2:[],

        yyform:{
          stepActive:1,//步骤
          yyName:'',//预约名称
          website:'',//预约网址
          isApprover:false,//是否有审批人
          device_name:'',//设备名称
          device_id:'',//设备id
          space_id:[],//空间id
          type:'',//设备类型
          depart_id:[],
          user_id:'',//用户id
        },
        approverList:[],//审批人列表
        rules4:{
          yyName:[
            { required: true, message: '请输入预约名称', trigger: 'blur' },
          ],
          website:[
            { required: true, message: '请输入预约网址', trigger: 'blur' },
          ],
        },
        yyform2:{
          mode:'1',//查找方式
          space_id:[],//空间id
          device_id:[],//选中设备
          type:'',//设备类型
          typeCode:'',
          typeSpecif:'A',//门禁级别
        },
        //穿梭框配置
        transProps:{
          key:'device_no_id',
          label:'device_name',
        },
        deviceType:[],
        deviceList3:[],
        deparList:[],//部门树形
        userYyList:[],//审批人下拉

        smzfform:{
          stepActive:1,//步骤
          tactics_id:'',//价格id
          tactics_name:'',//价格名称
          payPlat:'1',//支付平台,1微信；2支付宝
          payMethod:'1',//支付方式；1按时间；2按次数
          price:'',//费用
          weekend:false,//周末费用
          weekPrice:'',
          holiday:false,//节假日费用
          holiPrice:'',
          device_name:'',//设备名称
          device_id:'',//设备id
          space_id:[],//空间id
          type:'',//设备类型
        },
        tacticsList:[],//价格策略列表
        deviceList4:[],
        deviceList5:[],
        rules5:{
          tactics_id:[
            { required: true, message: '请选择价格策略', trigger: 'blur' },
          ],
          tactics_name:[
            { required: true, message: '请输入价格名称', trigger: 'blur' },
          ],
          price:[
            { required: true, message: '请输入费用', trigger: 'blur' },
          ],
        },

        leftinfo:{
          checkAll:false,
          total:0,
          checkNum:0,
          ischeck:[],
          isIndeterminate: false,
          deviceData:[],
          keyword:'',
        },
        rightinfo:{
          checkAll:false,
          total:0,
          checkNum:0,
          ischeck:[],
          isIndeterminate: false,
          deviceData:[],
          keyword:'',
        },

        mjyyform:{
          addStep:1,//步骤
          projectName:'',//项目名称
          projectUrl:'',//项目地址
          isIndeterminate:false,//全选状态
          checkAll:false,//是否全选
          space_id:'',//当前空间id
          sizeCheck:['A','B','C'],//门禁大小
          search:'',//设备搜索
          device_id:[],
          search2:'',//用户搜索
          userName:'',//审批人
          user_id:'',//选中的用户
          depart_id:'',//部门当前选中
          isCheck:false,//默认不勾选
        },
        allDeviceMjyy:[],//所有设备
        deviceListMjyy:[],
        auditorListMjyy:[],//门禁预约用户列表
        allUserMjyy:[],//所有设备
        treeProps2:{
          label: 'name',
          id: 'id',
          children: 'children'
        },
        treeProps:{
          label: 'space_name',
          id: 'space_id',
          children: 'children'
        },
      };
    },
    mounted(){
      this.getSpaceList()
      this.getDepartmentList();
    },
    created: async function () {
      this.getBussiness()
    },
    methods: {
      //提交配置
      async submitConfigMjyy(codeType){
        let that = this
        var dataObj = {
          'audit_name':that.mjyyform.projectName,//预约名称
          'device_no_id':that.mjyyform.device_id,//设备组
          'code_type': codeType,//1门禁 2会议室
        }
        if(codeType == '2'){
          dataObj.address = that.mjyyform.projectUrl
        }
        if(that.mjyyform.isCheck==true){
          if(that.mjyyform.user_id == ''){
            showToast('请选择审批人')
            return
          }
          dataObj.user_id=that.mjyyform.user_id
        }
        var res = await bussinessApi.configYuyue(dataObj)
        
        if (res.meta.code == 200) {
          that.mjyyform={
            addStep:1,//步骤
            projectName:'',//项目名称
            isIndeterminate:false,//全选状态
            checkAll:false,//是否全选
            space_id:'',//当前空间id
            sizeCheck:['A','B','C'],//门禁大小
            search:'',//设备搜索
            device_id:[],
            search2:'',//用户搜索
            userName:'',//审批人
            user_id:'',//选中的用户
            depart_id:'',//部门当前选中
            isCheck:false,//默认不勾选
          }
          that.deviceListMjyy=[]
          that.auditorListMjyy=[]
          that.configDio = false
          showToast('配置成功！')
          
        }else{
          showToast(res.meta.message)
        }
      },
      //同步当前选中的审批人
      getuserNameMjyy(val){
        this.mjyyform.userName = this.auditorListMjyy.find(item => item.user_id === val)["user_name"];
      },
      //门禁 - 上一步
      prevStepMjyy(){
        let that = this;
        if(that.mjyyform.addStep == 3){
          that.mjyyform.addStep = 2
        }else if(that.mjyyform.addStep == 2){
          that.mjyyform.addStep = 1
        }
      },
      //门禁 - 下一步
      nextStepMjyy(type){
        let that = this
        if(type == '1'){
          if(that.mjyyform.addStep == 1){
            if(that.mjyyform.projectName == ''){
              showToast('请输入项目名称')
              return
            }else if(that.mjyyform.projectName.length > 20){
              showToast('项目名称不能大于20位')
              return
            }
            that.mjyyform.addStep = 2
          }else if(that.mjyyform.addStep == 2){
            if(that.mjyyform.device_id == ''){
              showToast('请选择门禁设备')
              return
            }
            that.mjyyform.addStep = 3
          }
        }else if(type == '2'){
          if(that.mjyyform.addStep == 1){
            if(that.mjyyform.projectName == ''){
              showToast('请输入会议室名称')
              return
            }else if(that.mjyyform.projectName.length > 10){
              showToast('会议室名称不能大于10位')
              return
            }
            if(that.mjyyform.projectUrl == ''){
              showToast('请输入会议室地址')
              return
            }else if(that.mjyyform.projectUrl.length > 20){
              showToast('会议室地址不能大于20位')
              return
            }
            that.mjyyform.addStep = 2
          }else if(that.mjyyform.addStep == 2){
            if(that.mjyyform.device_id == ''){
              showToast('请选择会议室设备')
              return
            }
            that.mjyyform.addStep = 3
          }
        }
      },
      //门禁 - 通过部门获取审批人
      async getUserMjyy(depart_id){
        let that = this
        const data = {
          'perPage':99999,
          'department_id':depart_id
        }
        const res = await userApi.getUserList(data)
        if (res.meta.code === 200) {
          that.allUserMjyy = res.data.list
          // that.auditorListMjyy = res.data.list
          that.searchUserMjyy()
        } else {
          showToast(res.meta.message)
        }
      },
      //门禁- 搜索筛选
      searchUserMjyy(){
        let that = this;
        var allUser = this.allUserMjyy
        var searchList = []
        for(var i in allUser){
          if(that.mjyyform.search2!=''){
            if(allUser[i].user_name.indexOf(that.mjyyform.search2) != -1 || allUser[i].phone_no.indexOf(that.mjyyform.search2) != -1){
              searchList.push(allUser[i])
            }
          }else{
            searchList = allUser
          }
        }
        // console.log('searchList',searchList)
        this.auditorListMjyy = searchList
      },
      
      //门禁 - 获取树形节点
      getNode2Mjyy(node){
        let that = this;
        this.mjyyform.depart_id = node.id
        //调用获取用户的接口
        this.getUserMjyy(node.id)
        // this.getSpaceDeviceSmzf(this.addform.type,'1',node.id)
      },
      //搜索筛选
      searchInputMjyy(){
        let that = this;
        var allDevice = this.allDeviceMjyy
        var searchList = []
        for(var i in allDevice){
          if(that.mjyyform.search!=''){
            if(allDevice[i].device_name.indexOf(that.mjyyform.search) != -1 || allDevice[i].device_no_id.indexOf(that.mjyyform.search) != -1){
              searchList.push(allDevice[i])
            }
          }else{
            searchList = allDevice
          }
        }
        // console.log('searchList',searchList)
        this.deviceList = searchList
      },
      //全选(添加)
      CheckAllChangeMjyy(val) {
        var arr = []
        for(var i in this.deviceList){
          arr.push(this.deviceList[i].device_no_id)
        }
        arr = Array.from(new Set(arr))
        this.mjyyform.device_id = val ? arr : [];
        this.mjyyform.isIndeterminate = false;
      },
      //选择多个(添加)
      CheckedItemChangeMjyy(value) {
        let checkedCount = value.length;
        this.mjyyform.checkAll = checkedCount === this.deviceList.length;
        this.mjyyform.isIndeterminate = checkedCount > 0 && checkedCount < this.deviceList.length;
      },
      //获取树形节点(添加)
      getNodeMjyy(node){
        let that = this;
        this.mjyyform.space_id = node.space_id
        //调用获取设备列表的接口
        this.getSpaceDeviceMjyy(node.space_id,'1',this.mjyyform.sizeCheck)
      },
      //获取树形节点(添加)
      getNodeMjyy2(node){
        let that = this;
        this.mjyyform.space_id = node.space_id
        //调用获取设备列表的接口
        this.getSpaceDeviceMjyy(node.space_id,'2')
      },

      //跳转到详情
      toDetail(type_id){
        let that = this;
        var navBarActive=[]
        switch (type_id) {
          case 'ez':
            navBarActive = [{function_tab: 'CESite', function_name: 'E站业务详情'}]
            // 更新面包屑内容
            updataBreadCrumb(3, navBarActive)
            that.$router.push({
              path:'/CESite',
            })
            break;
          case 'wrc':
            navBarActive = [{function_tab: 'CUnmanWarehouse', function_name: '无人仓业务详情'}]
            // 更新面包屑内容
            updataBreadCrumb(3, navBarActive)
            that.$router.push({
              path:'/CUnmanWarehouse',
            })
            break;
          case 'jtws':
            navBarActive = [{function_tab: 'CFamilyGuard', function_name: '家庭卫士业务详情'}]
            // 更新面包屑内容
            updataBreadCrumb(3, navBarActive)
            that.$router.push({
              path:'/CFamilyGuard',
            })
            break;
          case 'kd':
            navBarActive = [{function_tab: 'CExpress', function_name: '快递业务详情'}]
            // 更新面包屑内容
            updataBreadCrumb(3, navBarActive)
            that.$router.push({
              path:'/CExpress',
            })
            break;
          case 'smzf':
            navBarActive = [{function_tab: 'CTactics', function_name: '扫码支付业务详情'}]
            // 更新面包屑内容
            updataBreadCrumb(3, navBarActive)
            that.$router.push({
              path:'/CTactics',
            })
            break;
          case 'yy':
            navBarActive = [{function_tab: 'CMakeAppointment', function_name: '预约业务详情'}]
            // 更新面包屑内容
            updataBreadCrumb(3, navBarActive)
            that.$router.push({
              path:'/CMakeAppointment',
            })
            break;
          case 'mjyy':
            navBarActive = [{function_tab: 'CAccess', function_name: '门禁预约详情'}]
            // 更新面包屑内容
            updataBreadCrumb(3, navBarActive)
            that.$router.push({
              path:'/CAccess',
            })
            break;
          case 'hysy':
            navBarActive = [{function_tab: 'CConference ', function_name: '会议室预约详情'}]
            // 更新面包屑内容
            updataBreadCrumb(3, navBarActive)
            that.$router.push({
              path:'/CConference',
            })
            break;
          default:
        }
      },
      //提交扫码支付配置
      submitSmzf(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.configSmzf()
          } else { return false;}
        });
      },
      async configSmzf(){
        let that = this;
        const data = {
          'space_id':that.smzfform.space_id[that.smzfform.space_id.length-1],
          'device_no_id':that.smzfform.device_id,
          'tactics_id':that.smzfform.tactics_id
        }
        const res = await bussinessApi.configSmzf(data)
        if (res.meta.code === 200) {
          that.smzfform.tactics_id=''
          that.smzfform.device_name=''
          that.smzfform.device_id=''
          that.smzfform.type=''
          that.smzfform.space_id=[]
          that.deviceList4=[]
          that.configDio = false
          showToast('配置成功！')
        } else {
          showToast(res.meta.message)
        }
      },
      //上一步
      prevStep(){
        this.gettacticsList()
        this.smzfform.stepActive = 1
      },
      //扫码支付获取设备
      async getSpaceDeviceSmzf(space_id){
        let that = this;
        const data = {
          'space_id': space_id,
        }
        let res = await bussinessApi.getSpaceDeviceSmzf(data)
        if(res.meta.code == 200){
          that.smzfform.device_id =''
          that.smzfform.type =''
          that.deviceList4 = res.data
        }else{
          showToast(res.meta.message)
        }
      },
      //扫码支付下一步
      nextStep2(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(that.smzfform.tactics_id == '0'){
              that.addTactics()
            }else{
              that.smzfform.stepActive = 2
            }
          } else { return false;}
        });
      },
      //添加价格策略
      async addTactics(){
        let that = this;
        const data = {
          'name': that.smzfform.tactics_name,
          'pay_way': that.smzfform.payPlat,
          'pay_type': that.smzfform.payMethod,
          'amount': that.smzfform.price,
          'amount_weekend': that.smzfform.weekend == true ? that.smzfform.weekPrice : '',
          'amount_holiday': that.smzfform.holiday == true ? that.smzfform.holiPrice : '',
        }
        const res = await bussinessApi.updateTactics(data)
        if (res.meta.code === 200) {
          that.smzfform.stepActive = 2
          that.smzfform.tactics_name=''
          that.smzfform.payPlat = ''
          that.smzfform.payMethod = ''
          that.smzfform.price = ''
          that.smzfform.weekend = false
          that.smzfform.holiday = false
          that.smzfform.weekPrice = ''
          that.smzfform.holiPrice = ''
          that.smzfform.tactics_id = res.data
        } else {
          showToast(res.meta.message)
        }
      },
      //价格策略列表
      async gettacticsList(){
        let that = this
        const res = await bussinessApi.tacticsList()
        if (res.meta.code === 200) {
          that.tacticsList = res.data.list
        } else {
          showToast(res.meta.message)
        }
      },
      //提交预约业务配置
      async submitYuyue(){
        let that = this
        var device_id =[]
        for(var i in that.rightinfo.deviceData){
          device_id.push(that.rightinfo.deviceData[i].device_no_id)
        }
        var dataObj = {
          'audit_name':that.yyform.yyName,//预约名称
          'qrcode_url':that.yyform.website,//预约地址
          'device_no_id':device_id,//设备id组
        }
        if(this.yyform.isApprover==true){
          dataObj.user_id=that.yyform.user_id
        }
        const res = await bussinessApi.configYuyue(dataObj)
        if (res.meta.code === 200) {
          that.yyform={
            stepActive:1,//步骤
            yyName:'',//预约名称
            website:'',//预约网址
            isApprover:false,//是否有审批人
            device_name:'',//设备名称
            device_id:'',//设备id
            space_id:[],//空间id
            type:'',//设备类型
            depart_id:[],
            user_id:'',//用户id
          }
          that.leftinfo={
            checkAll:false,
            total:0,
            checkNum:0,
            ischeck:[],
            isIndeterminate: false,
            deviceData:[],
            keyword:''
          }
          that.rightinfo={
            checkAll:false,
            total:0,
            checkNum:0,
            ischeck:[],
            isIndeterminate: false,
            deviceData:[],
            keyword:''
          }
          that.approverList=[]
          that.yyform2={
            mode:'1',//查找方式
            space_id:[],//空间id
            device_id:[],//选中设备
            type:'',//设备类型
            typeCode:'',
            typeSpecif:'A',//门禁级别
          }
          that.deviceType=[]
          that.deviceList5=[]
          that.deviceList3=[]
          that.deparList=[]
          that.userYyList=[]
          that.configDio = false
          showToast('配置成功！')
        } else {
          showToast(res.meta.message)
        }
      },
      //预约下一步
      nextStep3(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(that.yyform.isApprover == true){
              if(that.yyform.user_id==''){
                showToast('请选择审批人')
              }else{
                that.yyform.stepActive = 2
                that.getdeviceType()
              }
            }else{
              that.yyform.stepActive = 2
              that.getdeviceType()
            }
          } else { return false;}
        });
      },
      // 获取设备类型列表
      async getdeviceType() {
        let that = this
        const res = await bussinessApi.getDeviceTypeList()
        if (res.meta.code === 200) {
          that.deviceType = res.data.list
        } else {
          showToast(res.meta.message)
        }
      },
      //通过部门获取审批人
      async getUserYy(depart_id){
        let that = this
        const data = {
          'perPage':99999,
          'department_id':depart_id
        }
        const res = await userApi.getUserList(data)
        if (res.meta.code === 200) {
          that.userYyList = res.data.list
        } else {
          showToast(res.meta.message)
        }
      },
      // 获取部门列表
      async getDepartmentList() {
        let that = this
        const res = await userApi.getDepartmentList()
        if (res.meta.code === 200) {
          that.deparList = res.data
        } else {
          showToast(res.meta.message)
        }
      },
      //配置快递
      async configKuaidi(){
        let that = this;
        const arr = []
        for(let i in this.kdform.deviceData){
          const obj = {
            device_no_id:this.kdform.deviceData[i].device_id
          }
          arr.push(obj)
        }
        let x,y;
        const result = []
        for(x =0;x<arr.length;x++){
          for(y=x+1;y<arr.length;y++){
            if (arr[x].device_no_id == arr[y].device_no_id) {
              y = ++x
            }
          }
          result.push(arr[x])
        }
        if(that.kdform2.userData==''){
          showToast('请添加快递员')
        }else{
        const data = {
          'courierList': that.kdform2.userData,
          'deviceList': result
        }
        const res= await bussinessApi.configKuaidi(data)
        if(res.meta.code == 200){
          that.kdform={
            stepActive:1,//步骤
            device_name:'',//设备名称
            device_id:'',//设备id
            space_id:[],//空间id
            type:'',//设备类型
            fullname:'',//姓名
            phone:'',//手机号
            idcart:'',//身份证
            company:'',//快递公司
            deviceData:[],//设备表格
          };
          that.kdform2={
            fullname:'',//姓名
            phone:'',//手机号
            idcart:'',//身份证
            company:'',//快递公司
            userData:[],//用户表格
          };
          that.configDio = false;
          showToast('配置成功！')
        }else{
          showToast(res.meta.message)
        }
        }
      },
      //下一步
      nextStep(){
        if(this.kdform.deviceData !=''){
          this.kdform.stepActive = 2
        }else{
          showToast('请添加设备')
        }
      },
      //删除设备信息
      delDeviArr(index){
        this.kdform.deviceData.splice(index,1)
      },
      //添加设备信息到列表
      addDeviArr(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var obj = {
              'type':that.kdform.type,
              'device_id':that.kdform.device_id,
              'device_name':that.kdform.device_name,
            }
            that.kdform.deviceData.push(obj)
            that.kdform.type = ''
            that.kdform.device_id = ''
            that.kdform.device_name = ''
            that.kdform.space_id=[]
          } else { return false;}
        });
      },
      //删除用户信息
      delUserArr(index){
        this.kdform2.userData.splice(index,1)
      },
      //添加用户信息到列表
      addUserArr(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            var obj = {
              'user_name':that.kdform2.fullname,
              'phone_no':that.kdform2.phone,
              'identity':that.kdform2.idcart,
              'express_company':that.kdform2.company,
            }
            that.kdform2.userData.push(obj)
            that.kdform2.fullname = ''
            that.kdform2.phone = ''
            that.kdform2.idcart = ''
            that.kdform2.company=''
          } else { 
            return false;
          }
        });
      },
      //同步设备类型
      getDeviType(){
        let that = this;
        for(let i in this.deviceList2){
          if(that.deviceList2[i].device_no_id == this.kdform.device_id){
            that.kdform.type = that.deviceList2[i].device_type
            that.kdform.device_name = that.deviceList2[i].device_name
          }
        }
      },
      //同步设备类型
      // getDeviType2(){
      //   let that = this;
      //   for(let i in this.deviceList3){
      //     if(that.deviceList3[i].device_no_id == this.yyform.device_id){
      //       that.yyform.type = that.deviceList3[i].device_type
      //       that.yyform.device_name = that.deviceList3[i].device_name
      //     }
      //   }
      // },
      //同步设备类型
      getDeviType3(){
        let that = this;
        for(let i in this.deviceList4){
          if(that.deviceList4[i].device_no_id == this.smzfform.device_id){
            that.smzfform.type = that.deviceList4[i].device_type
            that.smzfform.device_name = that.deviceList4[i].device_name
          }
        }
      },
      //通过空间id获取预约的设备列表
      async getSpaceDeviceMjyy(space_id,type,size){
        let that = this;
        const data = {
          'space_id': space_id,
          // 'level_type': size.join(','),
          // 'code':'ACCESS',
        }
        if(type == '1'){
          // data.code = 'ACCESS'
          data.code_type = '1';//1门禁，2会议室，默认1
          data.level_type = size.join(',')
        }else if(type == '2'){
          // data.code = 'CONFERENCE'
          data.code_type = '2';//1门禁，2会议室，默认1
        }
        const res = await bussinessApi.getSpaceDeviceYy(data)
        if(res.meta.code == 200){
          that.allDeviceMjyy = res.data
          that.deviceListMjyy = res.data
        }else{
          showToast(res.meta.message)
        }
      },
      //通过空间id获取预约的设备列表
      async getSpaceDeviceYy(space_id){
        let that = this;
        const data = {
          'space_id': space_id,
        }
        let res = await bussinessApi.getSpaceDeviceYy(data)
        if(res.meta.code == 200){
          that.yyform2.device_id =[]
          // that.yyform.type =''
          that.deviceList5 = res.data
          that.leftinfo.total = res.data.length
          that.screenList()
        }else{
          showToast(res.meta.message)
        }
      },
      //切换类型（预约）
      typeChangeYy(){
        for(var i in this.deviceType){
          if(this.yyform2.type == this.deviceType[i].id){
            this.yyform2.typeCode=this.deviceType[i].code
          }
        }
        if(this.yyform2.typeCode=='ACCESS'){
          this.getDeviceListByType(this.yyform2.typeSpecif)
        }else{
          this.getDeviceListByType()
        }
      },
      //通过类型id获取预约的设备列表
      async getDeviceListByType(level){
        let that = this;
        var dataObj = {
          'id': that.yyform2.type,
        }
        if(level){
          dataObj.level_type=that.yyform2.typeSpecif
        }
        let res = await bussinessApi.getDeviceListByType(dataObj)
        if(res.meta.code == 200){
          that.yyform2.device_id =[]
          that.deviceList3 = res.data.list
        }else{
          showToast(res.meta.message)
        }
      },
      //穿梭框数据列渲染
      renderFunc(h, option) {
        return h('span',option.device_no_id+'-'+option.device_name)
      },
      //穿梭框自定义搜索逻辑
      filterMethod(query, item) {
        // console.log(query,item)
        return item.device_no_id.indexOf(query) > -1 ||item.device_name.indexOf(query) > -1;
      },
      //通过空间id获取快递的设备列表
      async getSpaceDeviceKd(space_id){
        let that = this;
        const data = {
          'space_id': space_id,
        }
        let res = await bussinessApi.getSpaceDeviceKd(data)
        if(res.meta.code == 200){
          that.kdform.device_id =''
          that.kdform.type =''
          that.deviceList2 = res.data
        }else{
          showToast(res.meta.message)
        }
      },
      //添加配置
      addConfig(formName){
        let that = this;
        this.$refs[formName].validate((valid) => {
          if (valid) {
            that.submitConfig()
          } else {
            return false;
          }
        });
      },
      //提交配置
      async submitConfig(){
        let that = this
        const data = {
          'original_data': that.addform.original_data,//子库
          'device_id': that.addform.device_id,//设备ID
          'desc': that.addform.desc,//备注
        }
        let res = await unmanApi.updateConfig(data)
        if(res.meta.code == 200){
          that.addform = {
            device_id:'',
            original_data:'',
            desc:''
          }
          that.spaceList=[]
          that.deviceList=[]
          that.configDio = false
          that.getWarehouse(1)
          showToast('添加成功！')
        }else{
          showToast(res.meta.message)
        }
      },
      //打开添加弹窗
      openAdd(type){
        let that = this;
        this.type_Dio=type;
        this.deviceList=[]
        this.deviceList2=[]
        this.deviceList3=[]
        // this.getSpaceList();
        if(type == 'yy'){
          this.deparList=[];
          this.userYyList=[];
          this.deviceList5=[]
          this.leftinfo={
            checkAll:false,
            total:0,
            checkNum:0,
            ischeck:[],
            isIndeterminate: false,
            deviceData:[],
            keyword:'',
          }
          this.rightinfo={
            checkAll:false,
            total:0,
            checkNum:0,
            ischeck:[],
            isIndeterminate: false,
            deviceData:[],
            keyword:'',
          }
          // this.getDepartmentList();
        }
        if(type == 'smzf'){
          this.tacticsList=[]
          this.gettacticsList()
        }
        if(type == 'mjyy'){
          this.mjyyform = {
            addStep:1,//步骤
            projectName:'',//项目名称
            isIndeterminate:false,//全选状态
            checkAll:false,//是否全选
            sizeCheck:['A','B','C'],//门禁大小
            search:'',//设备搜索
            device_id:[],
            search2:'',//用户搜索
            userName:'',//审批人
            user_id:'',//选中的用户
            isCheck:false,//默认不勾选
          }
          let space_id = this.mjyyform.space_id = this.spaceList[0].space_id
          let depart_id = this.mjyyform.depart_id = this.deparList[0].id
          this.getSpaceDeviceMjyy(space_id,this.mjyyform.sizeCheck,'1')
          this.getUserMjyy(depart_id)
        }
        if(type == 'hysy'){
          this.mjyyform = {
            addStep:1,//步骤
            projectName:'',//项目名称
            projectUrl:'',//项目地址
            isIndeterminate:false,//全选状态
            checkAll:false,//是否全选
            search:'',//设备搜索
            device_id:[],
            search2:'',//用户搜索
            userName:'',//审批人
            user_id:'',//选中的用户
            isCheck:false,//默认不勾选
          }
          let space_id = this.mjyyform.space_id = this.spaceList[0].space_id
          let depart_id = this.mjyyform.depart_id = this.deparList[0].id
          this.getSpaceDeviceMjyy(space_id,'2')
          this.getUserMjyy(depart_id)
        }
        this.titleDio = type == 'ez' ? '配置E站业务':
                        type == 'wrc' ? '配置无人仓业务':
                        type == 'kd' ? '配置快递业务':
                        type == 'smzf' ? '配置扫码支付业务':
                        type == 'yy' ? '配置预约业务':
                        type == 'mjyy' ? '配置门禁预约业务':
                        type == 'hysy' ? '配置会议室预约业务':''
        this.configDio = true;
      },
      //获取空间列表
      async getSpaceList(){
        let that = this
        let res = await sceneApi.space()
        if (res.meta.code === 200) {
          that.processScene(res.data)
        } else {
          showToast(res.meta.message)
        }
      },
      // 处理位置数据
      processScene(data) {
        let that = this
        if ( data.length !== 0) {
          // 显示某个公司或其下级空间的设备列表
          let list = data
          // 获取所属位置列表
          for (let s in list) {
            let area =  list[s].children
              // console.log('area', area, list[s].space_name)
            for (let i in area) {
              let street = area[i].children
              // console.log('street', street, area[i].space_name)
              for (let j in street) {
                let company = street[j]
                // console.log('company', company, company.space_name )
                that.spaceList.push(company)
              }
            }
          }
        }

      },
      //获取设备类型列表
      async getSpaceDeviceTypeList(space_id,type){
        let that = this;
        const data = {
          'space_id': space_id,
          'code': type
        }
        let res = await unmanApi.getSpaceDeviceTypeList(data)
        if(res.meta.code == 200){
          that.addform.device_id =''
          that.deviceList = res.data
        }else{
          showToast(res.meta.message)
        }
      },
      //修改业务
      async changeBussiness(){
        let that = this;
        const data = {
          'type_id': that.addbuss.bussiness
        }
        const res = await bussinessApi.changeBussiness(data)
        if(res.meta.code == 200){
          that.addbuss.bussiness=[]
          that.businessDio = false
          that.getBussiness()
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      //获取已启用业务
      async getBussiness(){
        let that = this;
        const res = await bussinessApi.getBussiness()
        if(res.meta.code == 200){
          that.bussinessList = res.data
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },
      openBussin(){
        this.getBussinessAll()
        
        this.businessDio = true
      },
      //获取所有业务
      async getBussinessAll(){
        let that = this;
        const res = await bussinessApi.getBussinessAll()
        if(res.meta.code == 200){
          for(let i in res.data){
            for(let ii in res.data[i].children){
              if(res.data[i].children[ii].is_delete == 'false'){
                that.addbuss.bussiness.push(res.data[i].children[ii].type_id)
              }
            }
          }
          // for(let i in that.bussinessList){
          //   for(let ii in that.bussinessList[i].children){
          //     that.addbuss.bussiness.push(that.bussinessList[i].children[ii].type_id)
          //   }
          // }
          that.allBussine = res.data
        }else{
          showToast(res.meta.message)
          // that.$message.error(res.meta.message)
        }
      },

      //预约的穿梭框
      //筛选穿梭框
      screenList(){
        let that = this;
        // console.log(this.leftinfo.keyword)
        for(var i in this.deviceList5){
          if(that.leftinfo.keyword!=''){
            if(that.deviceList5[i].device_name.indexOf(that.leftinfo.keyword) != -1 || that.deviceList5[i].device_no_id.indexOf(that.leftinfo.keyword) != -1){
              that.leftinfo.deviceData.push(that.deviceList5[i])
              // console.log('aa',that.leftinfo.deviceData)
            }
          }else{
            that.leftinfo.deviceData = that.deviceList5
            // console.log('bb',that.leftinfo.deviceData)
          }
        }
        // console.log('aa',that.deviceList5)
        // console.log('bb',that.leftinfo.deviceData)
      },
      screenList2(){
        let that = this;
        for(var i in this.deviceList3){
          if(that.rightinfo.keyword!=''){
            if(that.deviceList3[i].device_name.indexOf(that.rightinfo.keyword) != -1 || that.deviceList3[i].device_no_id.indexOf(that.rightinfo.keyword) != -1){
              that.rightinfo.deviceData.push(that.deviceList3[i])
            }
          }else{
            that.rightinfo.deviceData = that.deviceList3
          }
        }
      },
      //穿梭框左边迁移右边
      toRight(){
        let that = this
        var arr = this.leftinfo.ischeck
        var arr2 = this.leftinfo.deviceData
        for(var i in arr){
          for(var ii in arr2){
            if(arr[i] == arr2[ii].device_no_id){
              that.rightinfo.deviceData.push(arr2[ii])
              arr2.splice(ii,1)
            }
          }
        }
        for(var i in arr){
          for(var y in that.deviceList5){
            if(arr[i] == that.deviceList5[y].device_no_id){
              that.deviceList5.splice(y,1)
            }
          }
        }
        let obj = {}
        let arr3 = that.rightinfo.deviceData.reduce((cur,next) =>{
          obj[next.device_no_id] ? "" : obj[next.device_no_id] = true && cur.push(next);
          return cur;
        },[])
        this.rightinfo.deviceData = arr3
        this.leftinfo.deviceData = arr2
        this.rightinfo.total = this.rightinfo.deviceData.length
        this.leftinfo.ischeck = []
        this.leftinfo.checkNum = 0
        this.leftinfo.total = this.leftinfo.deviceData.length
        this.leftinfo.isIndeterminate = false;
        this.leftinfo.checkAll = false
      },
      //穿梭框右边迁移左边
      toLeft(){
        let that = this
        var arr = this.rightinfo.ischeck
        var arr2 = this.rightinfo.deviceData
        for(var i in arr){
          for(var ii in arr2){
            if(arr[i] == arr2[ii].device_no_id){
              that.leftinfo.deviceData.push(arr2[ii])
              arr2.splice(ii,1)
            }
          }
        }
        for(var i in arr){
          for(var y in that.deviceList3){
            if(arr[i] == that.deviceList3[y].device_no_id){
              that.deviceList3.splice(y,1)
            }
          }
        }
        let obj = {}
        let arr3 = that.leftinfo.deviceData.reduce((cur,next) =>{
          obj[next.device_no_id] ? "" : obj[next.device_no_id] = true && cur.push(next);
          return cur;
        },[])
        this.leftinfo.deviceData = arr3
        this.rightinfo.deviceData = arr2
        this.leftinfo.total = this.leftinfo.deviceData.length
        this.rightinfo.ischeck = []
        this.rightinfo.checkNum = 0
        this.rightinfo.total = this.rightinfo.deviceData.length
        this.rightinfo.isIndeterminate = false;
        this.rightinfo.checkAll = false
      },
      //穿梭框左边全选
      leftAllChange(val){
        let idList = []
        for(var i in this.leftinfo.deviceData){
          idList.push(this.leftinfo.deviceData[i].device_no_id)
        }
        this.leftinfo.ischeck = val ? idList : [];
        this.leftinfo.isIndeterminate = false;
        this.leftinfo.checkNum = this.leftinfo.ischeck.length
      },
      //穿梭框左边单选
      leftChange(value){
        let checkedCount = value.length;
        this.leftinfo.checkAll = checkedCount === this.leftinfo.deviceData.length;
        this.leftinfo.isIndeterminate = checkedCount > 0 && checkedCount < this.leftinfo.deviceData.length;
        this.leftinfo.checkNum = this.leftinfo.ischeck.length
      },
      //穿梭框右边全选
      rightAllChange(val){
        let idList = []
        for(var i in this.rightinfo.deviceData){
          idList.push(this.rightinfo.deviceData[i].device_no_id)
        }
        this.rightinfo.ischeck = val ? idList : [];
        this.rightinfo.isIndeterminate = false;
        this.rightinfo.checkNum = this.rightinfo.ischeck.length
      },
      //穿梭框右边单选
      rightChange(value){
        let checkedCount = value.length;
        this.rightinfo.checkAll = checkedCount === this.rightinfo.deviceData.length;
        this.rightinfo.isIndeterminate = checkedCount > 0 && checkedCount < this.rightinfo.deviceData.length;
        this.rightinfo.checkNum = this.rightinfo.ischeck.length
      },
    },
    watch: {
      "leftinfo.keyword":function(){
        this.leftinfo.deviceData=[]
        this.screenList()
      },
      "rightinfo.keyword":function(){
        this.rightinfo.deviceData=[]
        this.screenList2()
      },
    }
  }
</script>

<style lang="scss">
.CBusiness{
  .tc{
    text-align: center;
  }
  .minH300{
    min-height: 300px;
  }
  .tipsMjyy{
    color: #999;
    padding: 15px 0;
  }
  .stepMjyy{
    padding: 0;
    height: 30px;
    margin: 0 33px 0 18px;
    background: #DADADA;
    border-radius: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    .item{
      width: 33.33%;
      font-size: 12px;
      color: #fff;
      line-height: 30px;
      text-align: center;
      position: relative;
      &::after{
        content: "";
        position: absolute;
        right: -30px;
        top: 0;
        width: 0;
        height: 0;
        border-width: 15px;
        border-style: solid;
        border-color: transparent transparent transparent #DADADA;
        z-index: 10;
      }
      &.activeStep{
        background: #4BABFE;
        &::after{
          border-color: transparent transparent transparent #4BABFE;
        }
      }
    }
  }
  .tranferEdit{
    align-items: center;
    .tranItem{
      width: 255px;
      border: 1px solid #ebeef5;
      border-radius: 4px;
      max-height: 100%;
      box-sizing: border-box;
      overflow: hidden;
      .search{
        margin: 15px;
      }
      .tranTit{
        height: 40px;
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        box-sizing: border-box;
        background: #ebeef5;
        align-items: center;
      }
      .tranList{
        height: 194px;
        overflow-y: auto;
        overflow-x: hidden;
        box-sizing: border-box;
        .noData{
          text-align: center;
          padding: 20px;
        }
        .el-checkbox{
          padding: 0 15px;
          height: 30px;
          line-height: 30px;
          display: flex;
          align-items: center;
          .el-checkbox__label{
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
            height: 30px;
            line-height: 30px;
          }
        }
      }
    }
    .btnDiv{
      padding: 0 30px;
      .el-button{
        margin: 5px 0;
      }
    }
  }
  .el-transfer-panel{
    width: 255px;
  }
  .flex{
    display: flex;
  }
  .w185{
    width: 185px;
  }
  .week{
    height: 40px;
    align-items: center;
  }
  .cont{
    .tit{
      margin-bottom: 20px;
    }
    .list{
      flex-wrap: wrap;
      
      .item{
        width: 160px;
        height: 200px;
        margin-right:46px;
        margin-bottom: 30px;
        border: 1px solid #ddd;
        background: #008cff;
        padding: 10px 10px 0;
        position: relative;
        text-align: center;
        .img{
          height: 140px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          img{
            width: 50px;
            // height: 50px;
          }
        }
        .name{
          position: absolute;
          left: 0;
          bottom: 0px;
          height: 40px;
          line-height: 40px;
          width: 100%;
          background: #fff;
        }
        .itemBtn{
          position: absolute;
          left: 0;
          bottom: 0px;
          display: none;
          justify-content: center;
          width: 100%;
          background: #fff;
          color: #666;
          .btn{
            width: 50%;
            height: 40px;
            line-height: 40px;
            box-sizing: border-box;
            text-align: center;
            font-size: 14px;
            &+.btn{
              border-left: 1px solid #ddd;
            }
          }
        }
        &:hover .itemBtn{
          display: flex;
        }
      }
    }
  }
  .bussiDio{
    .tit{
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
    }
    .el-checkbox__input{
      display: none;
    }
    .el-checkbox.is-bordered{
      margin-bottom: 10px;
    }
  }
  .dib{
    display:inline-block;
  }
  .db{
    display:block;
  }
  .configDio{
    .titSubMjyy{
      height: 30px;
      padding: 0 10px;
      line-height: 30px;
      background: #E8E8E8;
      color: #333;
      box-sizing: border-box;
    }
    .selectedTree{
      font-weight: bold;
    }
    .authUserList{
      border: 1px solid #979797;
      align-items: flex-start !important;
      .userTree{
        width: 44%;
        height: 330px;
        overflow-y: auto;
        border-right: 1px solid #979797;
        flex-shrink: 0;
      }
      .checkList{
        flex-grow: 1;
        .search{
          // text-align: center;
          padding: 6px 0 0;
          display: flex;
          justify-content: center;
          align-items: center;
          .el-input{
            width: 50%;
            .el-input__inner{
              border-radius: 16px;
            }
          }
          .sizeDiv{
            margin-left: 10px;
            .el-checkbox{
              margin-right: 10px;
            }
          }
          &.pdtb6{
            padding: 6px 0;
          }
        }
        .el-checkbox.dblock,.el-radio.dblock{
          display: flex;
          justify-content: space-between;
          margin: 8px 0;
          flex-direction: row-reverse;
          padding-right: 16px;
          .el-checkbox__label,.el-radio__label{
            padding-left:16px;
          }
        }
        .el-checkbox-group.groupH{
          height: 227px;
          overflow-y: auto;
          border-top: 1px solid #eee;
        }
        .el-radio-group.groupH{
          display: block;
          height: 256px;
          overflow-y: auto;
          border-top: 1px solid #eee;
        }
      }
    }
    .flex{
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .tit{
      padding-left: 10px;
      padding-bottom: 10px;
      font-size: 14px;
      color: #333;
    }
    .authUser{
      border:1px solid #e4e7ed;
      align-items: flex-start;
      .userTree{
        width: 200px;
        border-right: 1px solid #e4e7ed;
        height: 300px;
        overflow-y: auto;
      }
      .checkList{
        flex: 1;
        height: 300px;
        overflow-y: auto;
        padding: 20px;
        .el-checkbox-group{
          display: flex;
          flex-wrap: wrap;
          .checkItem{
            width: 33.33%;
            .el-checkbox{ 
              margin-bottom: 10px;
              display: flex;
              align-items: center;
              .el-checkbox__label{
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
        }
        
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Page/CAuthorizationManage/CBusiness.vue